import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import Aura from '@primeng/themes/aura';

import { definePreset } from '@primeuix/styled';
import { ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';

const Noir = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{zinc.50}',
            100: '{zinc.100}',
            200: '{zinc.200}',
            300: '{zinc.300}',
            400: '{zinc.400}',
            500: '{zinc.500}',
            600: '{zinc.600}',
            700: '{zinc.700}',
            800: '{zinc.800}',
            900: '{zinc.900}',
            950: '{zinc.950}',
        }, colorScheme: {
            light: {
                primary: {
                    color: '#0078D6', // Highlight color
                    contrastColor: '#FFFFFF',
                    hoverColor: '#005BB5', // Slightly darker blue
                    activeColor: '#003A80', // Even darker blue
                },
                highlight: {
                    background: '#FFFFFF',
                    focusBackground: '#F4F4F4',
                    color: '#000000',
                    focusColor: '#000000',
                },
            },
            dark: {
                primary: {
                    color: '#008DFC', // Highlight color
                    contrastColor: '#0D0D0D',
                    hoverColor: '#0070C0', // Slightly lighter blue
                    activeColor: '#0056A0', // Even lighter blue
                },
                highlight: {
                    background: 'rgba(255, 255, 255, 0.16)', // Highlight for dark
                    focusBackground: 'rgba(255, 255, 255, 0.24)', // Focus highlight
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)',
                },
            },
        },
    },
});

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        provideHttpClient(),
        providePrimeNG({
            theme: {
                preset: Noir,
                options: {
                    darkModeSelector: '.dark-mode',
                }
            },
            ripple: true,

        }),
        ConfirmationService
    ],
};
